import { AuthLevel, generateApiPath } from '@guiker/api-definition'

const paths = {
  backgroundCheck: generateApiPath({ prefix: AuthLevel.AUTH, name: 'background-check' }),
  profile: generateApiPath({ prefix: AuthLevel.AUTH, name: 'profile' }),
}

export { paths }
